/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_List_Gp_Createnew2Inputs */

const en_coinvestments_list_gp_createnew2 = /** @type {(inputs: Coinvestments_List_Gp_Createnew2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create New Co-investment`)
};

/**
* | output |
* | --- |
* | "Create New Co-investment" |
*
* @param {Coinvestments_List_Gp_Createnew2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_list_gp_createnew2 = /** @type {((inputs?: Coinvestments_List_Gp_Createnew2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_List_Gp_Createnew2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_list_gp_createnew2(inputs)
});
export { coinvestments_list_gp_createnew2 as "coInvestments_list_gp_createNew" }